import React from "react";
import PropTypes from "prop-types";

class Tip extends React.Component {
    render() {
        const { resource } = this.props;
        const { description, title } = resource;

        return (
            <article className="tip">
                <figure className="tip__fig">
                    <i className="fal fa-exclamation" />
                </figure>
                <aside className="tip__description">
                    <h3 className="resources__title">{title}</h3>
                    <p className="resources__copy">{description}</p>
                </aside>
            </article>
        );
    }
}

export default Tip;



// WEBPACK FOOTER //
// ./src/components/Tip.js